// Sound URL registry.
// Every named cue in the audio system can be backed by a real audio file.
// - Set `null` → the synthesized fallback is used (works offline).
// - Set to a URL (e.g. "/sounds/rifle_shoot.mp3" or a CDN URL) → real asset
//   is loaded on demand and played instead of the synthesized version.
//
// To ship a real sound pack:
//  1. Drop your files into /app/frontend/public/sounds/  (see README there)
//  2. Point the entries below at "/sounds/<filename>".
//  3. That's it — no other file needs to change.
//
// You can mix and match: keep synthesized menu clicks, use real gunshots, etc.
export const SOUND_URLS = {
    // Intro
    axisIn: null,
    axisImpact: null,
    axisOut: null,
    blackTransition: null,
    titleIn: null,
    titleImpact: null,
    titleSweep: null,
    menuEnter: null,

    // Menu UI
    hover: null,
    click: null,
    open: null,
    close: null,

    // Weapons (per weapon SFX slots — see /game/weapons/weapons.js)
    shoot_rifle: null,
    shoot_smg: null,
    shoot_pistol: null,
    reload_rifle: null,
    reload_smg: null,
    reload_pistol: null,

    // Legacy aliases (still supported)
    shoot: null,
    reload: null,

    // Gameplay
    hit: null,
    footstep: null,
    weapon_switch: null,

    // Match flow
    victory: null,
    defeat: null,
};

// Cross-fade in/out settings for looping ambience (unused for one-shots).
export const SOUND_OPTIONS = {
    ambienceFadeMs: 2500,
};
